/* >>> ty-wl-reload (16.09.2026) */
/* הטופס נשלח רגיל ומרענן את הדף, והדף נוחת על הודעת ההצלחה.
   ההסבר המלא: shopify-agent/scripts/apply-waitlist-reload-2026-09-16.mjs */
(function () {
  'use strict';
  if (window.__tywReload) return;
  window.__tywReload = true;
  /* ① כיבוי השליחה במסגרת הנסתרת שמתחת. הדפים אסורים בתוך מסגרת,
        ולכן הודעת ההצלחה לא הופיעה מעולם. נמדד 16.09.2026. */
  window.__tywInline = true;

  /* ② נחיתה אחרי הרשמה */
  if (!/[?&]customer_posted=true/.test(window.location.search)) return;
  var ok = null;
  var list = document.querySelectorAll('[data-tyw-ok]');
  for (var i = 0; i < list.length; i++) { if (!list[i].hidden) { ok = list[i]; break; } }
  if (!ok) return;

  /* global.js קורא את העוגן ב-DOMContentLoaded וגולל שוב אחרי 500ms.
     בלי עוגן הוא אינו עושה דבר, ולכן יש רק גלילה אחת. */
  if (window.location.hash) {
    try { window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search); } catch (e) {}
  }

  var touched = false;
  var mark = function () { touched = true; };
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (t) {
    window.addEventListener(t, mark, { passive: true });
  });

  var land = function () {
    if (touched) return;
    var r = ok.getBoundingClientRect();
    var top = window.pageYOffset + r.top - Math.max(0, (window.innerHeight - r.height) / 2);
    top = Math.max(0, Math.round(top));
    if (Math.abs(window.pageYOffset - top) < 2) return;
    try { window.scrollTo({ top: top, behavior: 'instant' }); } catch (e) { window.scrollTo(0, top); }
  };
  land();
  try { ok.focus({ preventScroll: true }); } catch (e) {}
  /* תמונות שנטענות מעל הטופס יכולות להזיז אותו. מתקנים פעם אחת, אם הלקוח לא גלל בעצמו. */
  window.addEventListener('load', land, { once: true });
})();
/* <<< ty-wl-reload */

/**
 * ty-waitlist-inline.js
 *
 * ההרשמה נשלחת בלי שהדף מתרענן. הטופס מתחלף בהודעת ההצלחה במקום שבו
 * הוא יושב. נבנה 10.09.2026, בקשת יובל: «אחרי ההרשמה הדף מתרענן והכל
 * קופץ. אפשר שפשוט אחרי ההרשמה תופיע הודעת ההצלחה?»
 *
 * ── 🔴 למה זה `target` ולא `fetch`, וזה נמדד ולא הונח ────────────────────
 *
 * שליחה ב-fetch **אינה יכולה לעבוד כאן**, וזו לא שאלה של מימוש.
 * הגנת הבוטים של שופיפיי רושמת מאזין `submit` על `document` בשלב הבעבוע,
 * והוא נרשם **ראשון**, מתוך סקריפט מוטמע בגוף העמוד. הוא קורא
 * `preventDefault()` על השליחה הראשונה, מתמיד את השדות ב-sessionStorage,
 * מוסיף `form_key`, ורק אז שולח בעצמו.
 *
 * נמדד 10.09.2026 בערכת מעבדה, עם חסימת הבקשה ברשת כדי שדבר לא ייכתב:
 *   · אירוע ה-submit יצא
 *   · כשהגיע ל-window הוא כבר היה `defaultPrevented === true`
 *   · המאזין שלנו **לא רץ בכלל**, והכפתור לא זז
 * ⟹ כל מימוש שנשען על «אני עוצר ושולח בעצמי» הוא קוד מת, שנראה עובד.
 *
 * ✅ מה כן עובד: שופיפיי מסיימת ב-`form.submit()`, וזו קריאה שמכבדת את
 *    `form.target`. ⟹ אנחנו **לא עוצרים כלום**. הטופס נשלח בדיוק כמו
 *    קודם, עם הקפצ'ה ועם ה-form_key, ורק **התשובה** נוחתת במסגרת נסתרת
 *    במקום להחליף את הדף.
 *
 * ⚠️ **המחיר, וצריך לדעת עליו:** המסגרת טוענת את דף המוצר עוד פעם אחת,
 *    כלומר צפייה נוספת אחת בכלי המדידה לכל הרשמה. הבדיקה של lazy-load
 *    בתמה כן מזהה מסגרת ומדלגת, ולכן הטעינה הזו קלה מהרגילה.
 *
 * 🔴 נפילה חזרה, תמיד: תשובה שאינה «נרשם» מעבירה את הדף עצמו לאותה
 *    כתובת, כלומר הלקוח רואה בדיוק את מה שהיה רואה בלי הקובץ הזה.
 *    ובלי JS בכלל הטופס עובד כמו קודם, ו-`posted_successfully?` מציג
 *    את ההודעה אחרי הרענון.
 */
(function () {
  'use strict';

  if (window.__tywInline) return;
  window.__tywInline = true;

  var FRAME = 'tyw-inline-frame';
  var BTN_WAIT = 'רגע…';
  var GIVE_UP = 30000; // אחרי זה הכפתור חוזר, אבל ההאזנה נשארת

  function frameEl() {
    var f = document.getElementById(FRAME);
    if (f) return f;
    f = document.createElement('iframe');
    f.id = FRAME;
    f.name = FRAME;
    f.title = 'שליחת ההרשמה';
    f.setAttribute('aria-hidden', 'true');
    f.tabIndex = -1;
    f.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;border:0';
    document.body.appendChild(f);
    return f;
  }

  function showOk(form) {
    var wrap = form.closest('.tyw') || form.parentNode;
    var ok = wrap.querySelector('[data-tyw-ok]');
    var live = wrap.querySelector('[data-tyw-live]');
    if (!ok) return false;
    if (live) live.hidden = true;
    ok.hidden = false;
    // מיקוד בלי גלילה: קורא מסך מכריז את ההודעה, והדף עצמו אינו זז.
    try { ok.focus({ preventScroll: true }); } catch (e) {}
    return true;
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('tyw__form')) return;
      // 🔴 לא נוגעים באירוע. אם הוולידציה או הקפצ'ה עוצרות, שיעצרו.
      //    כל מה שאנחנו עושים הוא לומר לאן התשובה תיכנס.
      if (form.dataset.tywArmed === '1') return;

      var f = frameEl();
      form.target = FRAME;
      form.dataset.tywArmed = '1';

      var btn = form.querySelector('.tyw__btn');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = BTN_WAIT; }

      var free = function () {
        form.dataset.tywArmed = '';
        if (btn) { btn.disabled = false; btn.textContent = label; }
      };

      var onLoad = function () {
        var url = '';
        try { url = f.contentWindow.location.href; } catch (err) { url = ''; }
        if (!url || url === 'about:blank') return; // הטעינה הריקה הראשונה

        f.removeEventListener('load', onLoad);
        window.clearTimeout(timer);

        if (/[?&]customer_posted=true/.test(url)) {
          if (showOk(form)) {
            // עוצר כל מה שרץ בתוך המסגרת, מיד אחרי שקראנו את הכתובת
            f.src = 'about:blank';
            return;
          }
        }
        // 🔴 כל דבר אחר: הלקוח רואה את מה שהיה רואה ממילא.
        form.target = '';
        free();
        window.location.href = url;
      };

      var timer = window.setTimeout(free, GIVE_UP);
      f.addEventListener('load', onLoad);
    },
    false
  );
})();

/* >>> ty-wl-errors (14.09.2026) */
/* הודעת שגיאה שלנו במקום הבועה של הדפדפן. ההסבר המלא בכלי
   shopify-agent/scripts/apply-waitlist-errors-2026-09-14.mjs */
(function () {
  'use strict';
  if (window.__tywErrors) return;
  window.__tywErrors = true;

  var MSG = {"name":"שם","tel":"מספר טלפון","email":"אימייל","consent":"כדי להירשם, יש לסמן את האישור לקבלת דיוור.","emailBad":"כתובת האימייל אינה תקינה.","other":"אחד השדות אינו תקין."};

  function isOurs(form) { return !!(form && form.classList && form.classList.contains('tyw__form')); }

  function joinHe(items) {
    if (items.length < 2) return items.join('');
    return items.slice(0, -1).join(', ') + ' ו' + items[items.length - 1];
  }

  function summaryBox(form) {
    var box = form.querySelector('.tyw__errsum');
    if (box) return box;
    box = document.createElement('p');
    box.className = 'tyw__errsum';
    box.setAttribute('role', 'alert');
    box.hidden = true;
    var fields = form.querySelector('.tyw__fields');
    if (fields) fields.insertAdjacentElement('afterend', box);
    else form.appendChild(box);
    return box;
  }

  function render(form, moveFocus) {
    var missing = [], notes = [], first = null;
    // 🔴 כותבים רק כשמשהו השתנה. classList.add ו-setAttribute יוצרים רשומת שינוי
    //    גם כשהערך זהה, ובהקלדה זה הצטבר ל-163 שינויים ב-2 שניות. Bitwarden סוגר
    //    את התפריט שלו מעל 100 שינויים ב-2 שניות. נמדד במעבדה 14.09.2026.
    Array.prototype.forEach.call(form.elements, function (c) {
      if (!c.willValidate || c.type === 'hidden' || c.type === 'submit') return;
      if (c.validity.valid) {
        if (c.classList.contains('tyw-invalid')) c.classList.remove('tyw-invalid');
        if (c.getAttribute('aria-invalid') === 'true') c.removeAttribute('aria-invalid');
        return;
      }
      if (!first) first = c;
      if (!c.classList.contains('tyw-invalid')) c.classList.add('tyw-invalid');
      if (c.validity.customError) return;              // il-form-validation כבר מציג טקסט
      if (c.getAttribute('aria-invalid') !== 'true') c.setAttribute('aria-invalid', 'true');
      if (c.type === 'checkbox') { notes.push(MSG.consent); return; }
      if (c.validity.valueMissing) {
        missing.push(c.type === 'tel' ? MSG.tel : c.type === 'email' ? MSG.email : MSG.name);
        return;
      }
      notes.push(c.type === 'email' ? MSG.emailBad : MSG.other);
    });

    var text = (missing.length ? 'נא למלא ' + joinHe(missing) + '. ' : '') + notes.join(' ');
    var box = summaryBox(form);
    text = text.replace(/\s+$/, '');
    if (box.textContent !== text) box.textContent = text;
    if (box.hidden !== !text) box.hidden = !text;

    if (moveFocus && first) {
      try { first.focus({ preventScroll: true }); } catch (e) {}
      var r = first.getBoundingClientRect();
      if (r.top < 90 || r.bottom > window.innerHeight - 20) {
        first.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  }

  // invalid אינו מבעבע, ולכן לכידה. כל השדות החסרים יורים ברצף, ולכן ציור אחד.
  document.addEventListener('invalid', function (e) {
    var el = e.target, form = el && el.form;
    if (!isOurs(form)) return;
    e.preventDefault();
    if (form.tywErrPending) return;
    form.tywErrPending = true;
    window.setTimeout(function () { form.tywErrPending = false; render(form, true); }, 0);
  }, true);

  // תוך כדי תיקון ההודעה מתעדכנת, ונעלמת כשאין מה לתקן.
  function onEdit(e) {
    var el = e.target, form = el && el.form;
    if (!isOurs(form)) return;
    var box = form.querySelector('.tyw__errsum');
    if (box && !box.hidden) render(form, false);
    else if (el.classList && el.classList.contains('tyw-invalid') && el.validity.valid) el.classList.remove('tyw-invalid');
  }
  document.addEventListener('input', onEdit, true);
  document.addEventListener('change', onEdit, true);
})();
/* <<< ty-wl-errors */
